import classNames from 'classnames'
import { Dropdown } from 'legacy/lut/library/dropdown'
import React, { useCallback, useEffect, useMemo, useState } from 'react'

import { Translation } from 'cng-common/features/translations/components/translation'
import { Button } from 'core-components/library/button'
import { Input } from 'core-components/library/inputs'
import { Static } from 'core-components/types'
import { Crud } from 'core/types/Crud'

import styles from './ItemsController.module.scss'

interface IProps {
  handleCloseEdit: (newValue: any[], fieldName: string) => void
  selectedValues?: { name: string }[]
  dataSource: { name: string }[]
  fieldName: string
  editable?: boolean
  textHeader?: string
  useTextInput?: boolean
  additionalField?: string
}

export const ItemsController = (props: IProps) => {
  const { editable, textHeader, fieldName, handleCloseEdit, additionalField } = props
  const [dataset, setDataset] = useState<any[]>([])
  const [dataSource, setDataSource] = useState<any[]>([])
  const [isAddItem, setAddItem] = useState(false)
  const [textValue, setTextValue] = useState<string>('')
  const [categorisedData, setCategorisedData] = useState<any[]>([])

  useEffect(() => {
    if (props.selectedValues && props.dataSource) {
      const newDataset: any[] = []
      props.selectedValues.forEach((value: any) => {
        const finded =
          props.dataSource && props.dataSource.find((item: any) => item.name === value.name)
        newDataset.push(finded)
      })
      setDataset([...newDataset])
    } else if (props.dataSource && props.useTextInput) {
      setDataset(props.dataSource)
    }
  }, [props.selectedValues, props.dataSource])

  useEffect(() => {
    if (props.dataSource) {
      if (props.useTextInput) {
        setDataSource(props.dataSource)
        if (additionalField) {
          setCategorisedData([...makeCategorizedArray(props.dataSource)])
        }
      } else {
        const arr = props.dataSource.filter((v) => !dataset.find((el) => el.name === v.name))
        setDataSource(arr)
        setCategorisedData([...makeCategorizedArray(arr)])
      }
    }
  }, [props.dataSource])

  const dropdownSource = useMemo(() => {
    const data = additionalField ? categorisedData : dataSource
    return new Crud({
      fetcher: new Static(data),
      keyField: 'name',
    })
  }, [categorisedData, dataSource])

  const makeCategorizedArray = (data: any[]): any[] => {
    if (data && data.length > 0 && additionalField) {
      const result: any[] = []
      let currValue = ''
      data.map((item) => {
        if (item[additionalField] !== currValue) {
          currValue = item[additionalField]
          const additionalItem = { ...item, className: 'disabled' }
          additionalItem.name = currValue
          result.push(additionalItem)
        }
        result.push({ ...item, className: 'italic' })
      })
      return result
    }
    return []
  }

  const addValue = useCallback(
    (value: any) => {
      let newDataset = dataset
      let item = null
      if (!props.useTextInput) {
        item = dataSource.find((v) => v.name === value)
        if (item && (!additionalField || item[additionalField] !== value)) {
          newDataset.push(item)
          setDataset([...newDataset])
          handleCloseEdit([...newDataset], fieldName)
          setAddItem(false)
        }
      } else {
        newDataset = newDataset.map((el) => el.name)
        if (newDataset.includes(value)) {
          return
        }
        newDataset.push(value)
        handleCloseEdit(newDataset, props.fieldName)
        setTextValue('')
      }
    },
    [dataset, props.useTextInput, props.additionalField, props.handleCloseEdit, dataSource]
  )

  const removeValue = useCallback(
    (index: number) => {
      let newDataset = dataset
      newDataset.splice(index, 1)
      if (!props.useTextInput) {
        setDataset([...newDataset])
        handleCloseEdit([...newDataset], fieldName)
      } else {
        newDataset = newDataset.map((el) => el.name)
        handleCloseEdit(newDataset, props.fieldName)
      }
    },
    [dataset, props.useTextInput, props.fieldName]
  )

  if (!dataset.length && !editable) {
    return null
  } else {
    return (
      <div className={textHeader ? styles['controller'] : undefined}>
        {textHeader && (
          <div className={styles['controller__header']}>
            <Translation text={textHeader} span />
          </div>
        )}
        <div className={styles['controller__list']}>
          {dataset.map((item, index) => {
            return (
              <div
                key={index}
                className={classNames(
                  styles['controller__list-item'],
                  editable ? styles['controller__list_item-hover'] : ''
                )}
              >
                {additionalField ? (
                  <>
                    <span className={styles['controller__list-item-text']}>
                      {item[additionalField]}
                    </span>
                    &nbsp;
                    <span className={styles['controller__list-item-text-sub']}>{item.name}</span>
                  </>
                ) : (
                  <span className={styles['controller__list-item-text']}>{item.name}</span>
                )}

                <div className={styles['controller__list-item-remove']}>
                  <span>|</span>
                  <i
                    className={classNames(
                      styles['controller__list-item-remove-icon'],
                      'kbase kbase-delete'
                    )}
                    onClick={() => {
                      removeValue(index)
                    }}
                  />
                </div>
              </div>
            )
          })}
          {(dataSource.length || props.useTextInput) && editable ? (
            !isAddItem ? (
              <Button
                className={styles.controller__add}
                iconButton={'kbase kbase-add'}
                onClick={() => {
                  setAddItem(true)
                }}
              />
            ) : (
              <>
                {!props.useTextInput ? (
                  <Dropdown
                    label={''}
                    source={dropdownSource}
                    classes={{
                      controlClasses: {
                        root: styles['controller__dropdown'],
                      },
                    }}
                    caption="name"
                    value={''}
                    onChange={(name: string) => {
                      addValue(name)
                    }}
                  />
                ) : (
                  <>
                    <Input
                      classes={{
                        root: styles['controller__input'],
                      }}
                      placeholder="Zip code"
                      value={textValue}
                      onChange={(val) => setTextValue(val)}
                    />
                    <Button
                      className={styles.controller__add}
                      iconButton={'kbase kbase-delete'}
                      onClick={() => {
                        addValue(textValue)
                        setAddItem(false)
                      }}
                    />
                  </>
                )}
                <Button
                  className={styles.controller__add}
                  iconButton={'kbase kbase-save'}
                  onClick={() => {
                    setAddItem(false)
                  }}
                />
              </>
            )
          ) : (
            <></>
          )}
        </div>
      </div>
    )
  }
}
